import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { getIconUrlPopups } from 'src/app/events/helpers/event-helper';

@Component({
  selector: 'app-card-event-content',
  templateUrl: './card-event-content.component.html',
  styleUrls: ['./card-event-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardEventContentComponent {
  /* @Input() titleCard: string = '';
  @Input() classHeader: string = 'empty';
  @Input() eventName?: string;

  icon: string = '';
  isEmptyEventName: boolean = false;
  isContentContainerActive: boolean = true; */

  @Input() idCard: string = '';

  constructor(private cdr: ChangeDetectorRef) {}

  /* ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventName']) {
      this.getIcon();
    }
  }

  ngOnInit(): void {
    if (this.eventName === undefined || this.eventName === '') {
      this.isEmptyEventName = true;
    }
    this.getIcon();
    this.cdr.detectChanges();
  }

  toggleContentContainer() {
    this.isContentContainerActive = !this.isContentContainerActive;
  }

  getIcon() {
    this.icon = getIconUrlPopups({ tipo: this.eventName! });
    this.cdr.detectChanges();
  } */
}
